import images from './images';

const Menu = [
    {
        text: 'Home',
        link: '/',
    },
    {
        text: 'About us',
        link: '/about',
    },
    {
        text: 'Services',
        link: '/service',
    },
    {
        text: 'Events',
        link: '/events',
    },
    {
        text: 'Get Started',
        link: '#quote',
    }
];
const ServicesData = [
    {
        titleone: 'Mobile App',
        titletwo: 'Development',
        link: '/service',
        itemclass: 'blight',
        imgURL: images.services01,
        details: 'We develop high-performance mobile applications that deliver seamless experiences across Android and iOS platforms. Our approach combines clean architecture, intuitive design, and robust functionality to build apps that are secure, scalable, and aligned with business goals. Whether enhancing an existing product or building a new app from scratch, we create solutions that drive engagement and real-world value.',
    },
    {
        titleone: 'Web',
        titletwo: 'Development',
        link: '/service',
        itemclass: 'bgreen',
        imgURL: images.services02,
        details: 'We build fast, secure, and scalable websites and web applications tailored to our clients’ business needs. Our development process focuses on performance, usability, and long-term maintainability, ensuring each solution integrates smoothly with existing systems or stands strong on its own. From simple websites to complex web platforms, we deliver reliable products designed to support growth and efficiency.',
    },
    {
        titleone: 'Product (UI/UX)',
        titletwo: 'Design',
        link: '/service',
        itemclass: 'bdark',
        imgURL: images.services03,
        details: 'We design intuitive, user-centered digital products that balance aesthetics with functionality. Our UI/UX process focuses on understanding user behavior, business goals, and technical constraints to create seamless and engaging experiences. From research and wireframes to high-fidelity designs and prototypes, we craft interfaces that are easy to use, visually appealing, and built to drive adoption and results.',
    },
    {
        titleone: 'Technology',
        titletwo: 'Integration',
        link: '/service',
        itemclass: 'blight',
        imgURL: images.services04,
        details: 'We are tech enthusiasts who design and implement technology-driven business solutions that fit seamlessly into our clients’ operations. Our goal is to improve efficiency, reduce costs, and boost profitability. Depending on each client’s unique needs, we either integrate our solutions into existing systems or build entirely new ones from the ground up.',
    },
    {
        titleone: 'Maintenance',
        titletwo: '& Support',
        link: '/service',
        itemclass: 'bgreen',
        imgURL: images.services08,
        details: 'We provide ongoing maintenance and reliable technical support to ensure our clients’ systems remain secure, stable, and up to date. Our team proactively monitors performance, resolves issues quickly, and implements updates and improvements to minimize downtime and keep business operations running smoothly. This allows our clients to focus on growth while we handle the technical upkeep',
    },
]
const CaseStudies = [
    {
        text: 'For a local restaurant, we implemented a targeted PPC campaign that resulted in a 50% increase in website traffic and a 25% increase in sales.',
        link: '#',
    },
];

const WorkingProcess = [
    {
        title: 'Consultation',
        description: 'During the initial consultation, we will discuss your business goals and objectives, target audience, and current marketing efforts. This will allow us to understand your needs and tailor our services to best fit your requirements.',
    },
    {
        title: 'Research and Strategy Development',
        description: 'During the initial consultation, we will discuss your business goals and objectives, target audience, and current marketing efforts. This will allow us to understand your needs and tailor our services to best fit your requirements.',
    },
    {
        title: 'Implementation',
        description: 'During the initial consultation, we will discuss your business goals and objectives, target audience, and current marketing efforts. This will allow us to understand your needs and tailor our services to best fit your requirements.',
    },
    {
        title: 'Monitoring and Optimization',
        description: 'During the initial consultation, we will discuss your business goals and objectives, target audience, and current marketing efforts. This will allow us to understand your needs and tailor our services to best fit your requirements.',
    },
    {
        title: 'Reporting and Communication',
        description: 'During the initial consultation, we will discuss your business goals and objectives, target audience, and current marketing efforts. This will allow us to understand your needs and tailor our services to best fit your requirements.',
    },
    {
        title: 'Continual Improvement',
        description: 'During the initial consultation, we will discuss your business goals and objectives, target audience, and current marketing efforts. This will allow us to understand your needs and tailor our services to best fit your requirements.',
    },

];

const Team = [
    {
        name: 'Chukwuemeka Osuji',
        position: ' Founder/CEO',
        info: '',
        foto: images.team02,
        linkedin: 'https://www.linkedin.com/in/chukwuemeka-osuji-485ba31b4',
    },
    {
        name: 'Chukwuemeka Nwachukwu',
        position: 'Co-founder & CTO',
        info: '',
        foto: images.team01,
        linkedin: 'https://www.linkedin.com/in/chukwuemekanwachukwu',
    },
    {
        name: 'Onyinye Nwachukwu',
        position: 'Product manager',
        info: '',
        foto: images.team03,
        linkedin: 'http://linkedin.com/in/onyinye-n',
    },
    {
        name: 'Uchechukwu Nwokenne (ACA)',
        position: 'Operations Manager (Africa)',
        info: '',
        foto: images.team04,
        linkedin: 'https://www.linkedin.com/in/nwokenne-uchechukwu-gnim-aca-in-view?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
    },
    {
        name: 'Light Okorie',
        position: 'Social media Lead',
        info: '',
        foto: images.team05,
        linkedin: 'https://www.linkedin.com/in/light-okorie-a90895335?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
    },
    {
        name: 'Ephraim Nwachukwu',
        position: 'Operations Manager (UK)',
        info: '',
        foto: images.team06,
        linkedin: 'https://www.linkedin.com/in/ephraim-nwachukwu-4a286118b?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app',
    },
    

];

const Testimonials = [
    {
        name: 'Chinonso Chukwuebuka',
        position: 'Wesell bills',
        testimonial: '"I have worked with Mc Heritage Consulting a few times and they were really helpful in crafting effective and unique marketing strategies for our business. I will definitely recommend them any day anytime"',
    },
];

const Footer = [
    {
        text: 'Home',
        link: '/',
    },
    {
        text: 'About us',
        link: '/about',
    },
    {
        text: 'Services',
        link: '/service',
    },
    {
        text: 'Events',
        link: '/events',
    },
    {
        text: 'Contact Us',
        link: '#quote',
    }
];
const EventsData = [
    {
        titleone: 'Students and Graduates in Tech 2025',
        link: '/service',
        itemclass: 'blight',
        imgURL: images.events01,
        imgURL2: images.events012,
        details: '  A tech conference for students and graduates',
        overview1: 'Overview',
        overview: '​The “Students And Graduates In Tech” is an annual tech conference for students and graduates of Universities in the United Kingdom, designed to bring together students and recent graduates, industry professionals, and innovators in the tech field. Our aim is to foster collaboration, inspire creativity, and provide networking opportunities and teach students how to transition and navigate through tech roles in the industry. The event will feature: Keynote speakers from leading tech companies, Workshops on the latest technologies and trends, Panel sessions with industry experts, Networking sessions to connect students with industry leaders, Exhibition of innovative tech products by individuals and companies.'
    }
];
export default { Menu, CaseStudies, WorkingProcess, Team, Testimonials, ServicesData, EventsData, Footer };